@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.package {
  margin-top: 10px;
  background-color: @multi-package-list--package--background-color;
  box-shadow: 1px 1px 3px @multi-package-list--package--box-shadow-color;
  width: 100%;
  flex-direction: column;
}
